import Timeline from '@images/key-capabilities/Timeline.png';
import Audio from '@images/key-capabilities/Audio.png';
import Camera from '@images/key-capabilities/Camera.png';
import * as React from 'react';
export default {
  Timeline,
  Audio,
  Camera,
  React
};